/**
 * Builds deep-links into the /book flow. The booking page (src/pages/book/index.js)
 * reads ?mkt (market shortName), ?svc (service name), and ?stp (serviceType name)
 * to preselect a service and open its modal. Market comes from the client-resolved
 * MarketContext, so callers pass the currently selected market.
 */

/**
 * @param {{ service: { name: string, serviceType?: { name?: string } }, market?: { shortName?: string } | null }} args
 * @returns {string}
 */
export const bookServiceHref = ({ service, market }) => {
  if (!market?.shortName) { return '/book' }
  const params = new URLSearchParams({ mkt: market.shortName, svc: service.name })
  const stp = service.serviceType?.name
  if (stp) { params.set('stp', stp) }
  return `/book?${params.toString().replace(/\+/g, '%20')}`
}
